import React from "react";
import Styled from './styles';

const BodyContent = ({children}) => {
    return <Styled>
        {children}
    </Styled>
}

export default BodyContent;